module.exports = __webpack_public_path__ + "img/pixel.9b6d7479.webp";